import { ClusteringBias } from "components/widgets/utility/ClusteringBias";

export type WordCloudSettingsStateType = {
  customWidgetTitle: string;
  dataKey?: string;
  colorKey?: string;
  excludedTerms?: string[];
  padding: number,
  spiralType: string,
  widgetTitle: string;
  widgetTitleAlignment: string;
  wordCount: number,
  clusteringBias?: ClusteringBias;
};

export const wordCloudDefaultSettings: WordCloudSettingsStateType = {
  customWidgetTitle: '',
  dataKey: 'relevance',
  colorKey: 'positivity',
  padding: 5,
  spiralType: 'archimedean',
  widgetTitle: 'none',
  widgetTitleAlignment: 'left',
  wordCount: 100,
  clusteringBias: ClusteringBias.Mid
};